export default __webpack_public_path__ + "static/media/app_vivid.dd706e7f.svg";